import { APP_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthGuard } from './shared/services/auth-guard.service';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { NgChartsModule } from 'ng2-charts';
import { NgxMaskModule } from 'ngx-mask';
import { provideEnvironmentNgxCurrency } from 'ngx-currency';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { AuthModule } from './auth/auth.module';
import { CommonModule, DatePipe } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { HttpErrorInterceptor } from './shared/interceptors/http-error-interceptor';

@NgModule({
  declarations: [

  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    DragDropModule,
    NgChartsModule,
    NgxMaskModule,
    NgxChartsModule,
    AuthModule,
    CommonModule,
    // 🟢 NOVO: Garante que o módulo HTTP nativo do Angular esteja registrado na raiz
    HttpClientModule, 
    ServiceWorkerModule.register('ngsw-worker.js', {
      //enabled: false,
      enabled: environment.production || environment.staging
      // Register the ServiceWorker as soon as the app is stable
      // or after 30 seconds (whichever comes first).
      //registrationStrategy: 'registerWhenStable:30000'
    }),
    BrowserAnimationsModule,
  ],
  providers: [
    AuthGuard,
    DatePipe,
    provideEnvironmentNgxCurrency({}),
    { provide: APP_ID, useValue: 'serverApp' },

    // 🟢 NOVO: Adicionando o Interceptor para capturar todos os erros 504 e falhas de rede (Status 0)
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorInterceptor,
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }